/* eslint-disable max-classes-per-file */
import { FormSelectOption } from '@/modules/core/form/models/FormSelectOption';
import Enum from '@/modules/core/app/models/abstracts/Enum';

export const EditableTypes = [
  { key: 'always', value: 'Always' },
  { key: 'edit_only', value: 'EditOnly' },
  { key: 'add_only', value: 'AddOnly' },
];

export const ParentFieldSupportedTypes = ['select', 'multi_select', 'checkbox', 'radio_button'];

export const SelectFieldTypes = {
  SINGLE_SELECT: 'select',
  MULTI_SELECT: 'multi_select',
};

export const DateFormatSelectOptions = new FormSelectOption({
  valueIsObject: false,
  getData: () => {
    const values = [
      { key: 'MM-DD-YYYY', value: 'MM-DD-YYYY' },
      { key: 'MMDDYYYY', value: 'MMDDYYYY' },
      { key: 'YYYYMMDD', value: 'YYYYMMDD' },
      { key: 'YYYY-MM-DD', value: 'YYYY-MM-DD' },
    ];
    return { values };
  },
});

export const MaximumNumberOfOptions = 9;

export const DateFieldSelectOptions = new FormSelectOption({
  valueIsObject: false,
  getData: () => {
    const values = [
      { key: 'date', value: 'Select Date' },
      { key: 'date_field', value: 'Date Field' },
    ];
    return { values };
  },
});

export class CalculationResultType extends Enum {
  static TEXT = 'string';

  static NUMBER = 'integer';

  static DECIMAL = 'decimal';

  static CURRENCY = 'currency';

  static PERCENT = 'percent';
}

export class RollupTargetResultType extends Enum {
  static DATE = 'date';

  static NUMBER = 'integer';

  static DECIMAL = 'decimal';

  static CURRENCY = 'currency';

  static PERCENT = 'percent';
}

export class DistributedTargetResultType extends Enum {
  static INTEGER = 'integer';

  static DECIMAL = 'decimal';

  static CURRENCY = 'currency';

  static PERCENT = 'percent';
}

export const DistributionTypes = [
  { key: 'distributed_by_entities', value: 'Distribution By Entities' },
  { key: 'distributed_by_days', value: 'Distribution By Days' },
];

export const FieldTypesToShowInCalculationBuilder = [
  'number',
  'currency',
  'percentage',
  'date',
  'calculation',
];

export class FieldType extends Enum {
  static SINGLE_LINE_TEXT = 'single_line_text';

  static MULTI_LINE_TEXT = 'multi_line_text';

  static SELECT = 'select';

  static MULTI_SELECT = 'multi_select';

  static NUMBER = 'number';

  static DECIMAL = 'decimal';

  static CURRENCY = 'currency';

  static PERCENTAGE = 'percentage';

  static EMAIL = 'email';

  static PHONENUMBER = 'phonenumber';

  static URL = 'url';

  static CHECKBOX = 'checkbox';

  static RADIO_BUTTON = 'radio_button';

  static DATE = 'date';

  static TIME = 'time';

  static FILE_UPLOAD = 'file_upload';

  static GEN_AI_IMAGE_UPLOAD = 'gen_ai_image_upload';

  static CALCULATION = 'calculation';

  static RATE_CARD = 'rate_card';

  static CURRENCY_RATE_CARD = 'currency_rate_card';

  static PERCENT_RATE_CARD = 'percentage_rate_card';

  static SINGLE_LINE_TEXT_RATE_CARD = 'single_line_text_rate_card';

  static SELECT_RATE_CARD = 'select_rate_card';

  static ROLLUP_TARGET = 'rollup_target';

  static DISTRIBUTED_TARGET = 'distributed_target';

  static GEO_TARGETING = 'geo_targeting';

  static FREQUENCY_CAP = 'frequency_cap';
}

export class FieldDataType extends Enum {
  static STRING = 'string';

  static INTEGER = 'integer';

  static PERCENT = 'percent';

  static CURRENCY = 'currency';

  static BOOL = 'bool';

  static DECIMAL = 'decimal';

  static ARRAY = 'array';

  static DATE = 'date';

  static TIME = 'time';

  static DATETIME = 'datetime';

  static OBJECT = 'object';

  static IMAGE = 'image';

  static AUDIO = 'audio';

  static ENUM = 'enum';

  static SET = 'set';

  static PHONENUMBER = 'phonenumber';

  static FILE = 'file';
}

export class FormDisplayMode extends Enum {
  static INFO = 'info';

  static PREVIEW = 'preview';

  static ADD = 'add';
}

export class FormPreviewLayout extends Enum {
  static VERTICAL = 'vertical';

  static HORIZONTAL = 'horizontal';
}

export const UniqueOptionName = 'Option should be unique';

export const FieldNameErrorMessage = 'Field name should not contain any special characters';

export const FieldEditableTypes = {
  ALWAYS: 'always',
  NONE: 'none',
  ADD_ONLY: 'add_only',
  EDIT_ONLY: 'edit_only',
};

export const FormFieldConstants = {
  OVERRIDDEN_FIELD_NAMES: '__OVERRIDDEN_FIELD_NAMES__',
  CONVERSION_POSSIBLE: '__CONVERSION_POSSIBLE__',
  FORCE_DELETE_EXISTING_VALUES: '__FORCE_DELETE_EXISTING_VALUES__',
  FORCE_CONVERT_EXISTING_VALUES: '__FORCE_CONVERT_EXISTING_VALUES__',
  NEW: 'new',
  DEFAULT_VALUE: 'default_value',
};

export const OverrideTooltipMessages = {
  OVERRIDE_MESSAGE: 'Click to override',
  CALCULATION_REMOVE_OVERRIDE_MESSAGE: 'Click to remove override and use calculated value',
  RATE_CARD_REMOVE_OVERRIDE_MESSAGE: 'Click to remove override and use rate card value',
  CASCADE_REMOVE_OVERRIDE_MESSAGE: 'Click to remove override and use cascade value',
  DISTRIBUTED_TARGET_REMOVE_OVERRIDE_MESSAGE:
    'Click to remove override and use distributed target value',
};

export const FieldEvents = {
  ON_CONFIRM_DELETE: 'on-confirm-delete',
  ON_CONFIRM_CONVERT: 'on-confirm-conversion',
  ON_CONFIRM_CANCEL: 'on-cancel',
  CHANGE: 'change',
};

export const OverrideConstant = 'override';

export const StartObject = '{';

export const RateCardFieldCreationConstants = {
  UPCOMING: ' (Upcoming)',
  PAST: ' (Past Rates)',
  FORMAT: 'M/D/YYYY',
  ID: '-id',
};

export const RateCardRoutes = {
  RATECARD_SAVEGROUP: 'ratecard/savegroup',
  RATECARD_DELETEGROUP: 'ratecard/deletegroup',
  RATECARD_MODIFY_EFFECTIVEDATE: 'ratecard/modifyeffectivedate',
};

export const ApiRoutePaths = {
  FieldModificationEffects: 'fieldModificationEffects',
  FieldModificationEffectsNewEntities: 'fieldmodificationeffectsnewentities',
  FieldModificationEffectsNewEntity: 'fieldModificationEffectsNewEntity',
  ReDistributeDryRun: 'redistributedryrun',
  ReDistributeValues: 'redistributevalues',
};

export const FrequencyCapUnits = {
  KEY_DAYS: 'days',
  KEY_WEEKS: 'weeks',
  KEY_HOURS: 'hours',
  KEY_LIFE_TIME: 'life_time',
  KEY_MINUTES: 'minutes',
  KEY_MONTHS: 'months',
  VALUE_DAY: 'Day',
  VALUE_WEEK: 'Week',
  VALUE_MONTH: 'Month',
  VALUE_MINUTE: 'Minute',
  VALUE_HOUR: 'Hour',
  VALUE_LIFE_TIME: 'Life Time',
  NUM_OF_UNIT: 'numOfUnit',
};

export const GeoTargetingConstants = {
  OPERATION_ROOT: 'ROOT',
  OPERATION_CHILDREN: 'CHILDREN',
  OPERATION_SEARCH: 'SEARCH',
  OPERATION_BULK_STATE: 'BULK_STATE',
  OPERATION_BULK_CITY: 'BULK_CITY',
  OPERATION_BULK_POSTAL_CODE: 'BULK_POSTAL_CODE',
  STATE: 'STATE',
  POSTAL_CODE: 'POSTAL_CODE',
  LOCATIONS: 'locations',
  IS_DANGER: 'is-danger',
  IS_LOADING: 'isLoading',
  CHILDREN_LOADED: 'childrenLoaded',
  CHILDREN: 'children',
  INCLUDE: 'include',
  EXCLUDED: 'excluded',
  INCLUDED: 'included',
  EXCLUDE: 'exclude',
  SOURCE_TEXT: 'text',
  SOURCE_PICKER: 'picker',
  INCLUDE_LIST: 'includeList',
  EXCLUDE_LIST: 'excludeList',
  TEXT_TYPE_STATE: 'States',
  TEXT_TYPE_CITY: 'Cities',
  TEXT_TYPE_POSTAL_CODE: 'Postal Codes',
  HOME: 'Home',
  ACTIVE: 'Active',
  SERVICE_TYPE: 'service_type',
  UNKNOWN: 'UNKNOWN',
};

export const ContentValueMixinConstants = {
  KEY: 'key',
  BASE: 'base',
  QUERY: 'query',
  NEW_VALUE: 'newValue',
};
